export default "__VITE_ASSET__efd8865b__"